import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseFinanceiraIniciarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisefinanceira`;
    }

    /** Inicia a análise financeira do cliente */
    iniciar(idCliente: number): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.put<ClienteAnaliseFinanceira>(`${this.pathApi}/${idCliente}/iniciar`, null);
    }

    /** Cancela o inicio da análise financeira */
    cancelarIniciar(idCliente: number): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.put<ClienteAnaliseFinanceira>(`${this.pathApi}/${idCliente}/iniciar/cancelar`, null);
    }
}
